import React from "react";
import AdGroupMediaCard from "./AdGroupMediaCard";

const AdGroupVideosCard = ({
  orgMedias,
  adgroupinfo,
  refetchAdGroupInfo,
  adGroupId,
}) => {
  return (
    <AdGroupMediaCard
      mediaType="VIDEO"
      orgMedias={orgMedias}
      adgroupinfo={adgroupinfo}
      refetchAdGroupInfo={refetchAdGroupInfo}
      adGroupId={adGroupId}
    />
  );
};

export default AdGroupVideosCard;